import { Avatar, Box } from "@mui/material";
import { styled } from "@mui/material";

export const CustomBox = styled(Box)(({ theme }) => ({
	padding: 2,
	borderRadius: 30,
	color: "white",
	textAlign: "center",
	display: "flex",
	alignItems: "center",
}));

export const CustomAvatar = styled(Avatar)(({ theme }) => ({
	border: "2px solid white",
	"& img": {
		objectPosition: "top",
	},
	marginRight: 10,
}));

const EscolaTaula = (props) => {
	const { value } = props;
	return (
		<CustomBox style={{ backgroundColor: value.color_alt }}>
			<CustomAvatar
				alt={value.nom}
				src={"https://api.sinapsisberga.cat/storage/" + value.imatge}
				style={{ backgroundColor: value.color }}
			/>
			{value.nom}
		</CustomBox>
	);
};

export default EscolaTaula;
